import { useEffect } from 'react'
import PropTypes from 'prop-types'
import QUERY_KEYS from '../../graphql/queryKeys'
import clientQuery from '../../graphql/queries/clientQuery'
import useQuery from '../../hooks/useQuery'
import { captureErrorAndNotify } from '../../utilities/errorHandlers'
import { replaceDynamicTags } from './replaceDynamicTags'

export default function ClientDetailsLoader ({
  clientId,
  content,
  companyName,
  requestId,
  onClientLoaded,
  onLoadingChange
}) {
  const {
    data: clientData,
    isFetching,
    isError
  } = useQuery(
    [QUERY_KEYS.client, clientId],
    clientQuery,
    {
      enabled: Boolean(clientId),
      onError (error) {
        captureErrorAndNotify(error, 'Error fetching account details')
      }
    }
  )

  useEffect(() => {
    onLoadingChange(isFetching)
  }, [
    isFetching,
    onLoadingChange
  ])

  useEffect(() => {
    if (!clientId) {
      return
    }
    if (isError) {
      onLoadingChange(false)
      onClientLoaded(clientId, requestId, content)
      return
    }
    if (!clientData) {
      return
    }
    const client =
      clientData?.client ||
      clientData
    if (!client) {
      return
    }
    const updatedContent =
      replaceDynamicTags(
        content,
        client,
        companyName
      )
    onClientLoaded(
      clientId,
      requestId,
      updatedContent
    )
  }, [
    clientData,
    clientId,
    companyName,
    content,
    isError,
    requestId,
    onClientLoaded,
    onLoadingChange
  ])

  return null
}

ClientDetailsLoader.propTypes = {
  clientId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  content: PropTypes.string.isRequired,
  companyName: PropTypes.string,
  requestId: PropTypes.number.isRequired,
  onClientLoaded: PropTypes.func.isRequired,
  onLoadingChange: PropTypes.func.isRequired
}

ClientDetailsLoader.defaultProps = {
  companyName: ''
}
